import React from 'react';
import { IconProps } from '../types';
const MinecraftFilledMapMarkings: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="8" y="4" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="9" y="5" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(255, 255, 255, 153)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(255, 255, 255, 217)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(0, 0, 0, 71)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(0, 0, 0, 71)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(0, 0, 0, 71)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(0, 0, 0, 71)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(255, 255, 255, 217)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(255, 255, 255, 153)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(255, 255, 255, 217)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(255, 255, 255, 153)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(255, 255, 255, 217)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(0, 0, 0, 71)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(255, 255, 255, 255)" />
</svg>);
export default MinecraftFilledMapMarkings;